import Vue from "vue";

export const createExceptionWordsController = () => {
  const state = Vue.observable({
    visible: false,
    text: "",
    style: {},
    placement: "bottom",
  });

  let activeTableBody = null;
  let scrollHandler = null;

  const hide = () => {
    state.visible = false;

    if (window.getSelection) {
      window.getSelection().removeAllRanges();
    }

    if (activeTableBody && scrollHandler) {
      activeTableBody.removeEventListener("scroll", scrollHandler);
      activeTableBody = null;
      scrollHandler = null;
    }
  };

  const show = ({ text, rect, target }) => {
    const element = target?.nodeType === 3 ? target.parentElement : target;
    const tableBody =
      element?.closest(".table-body") || document.querySelector(".table-body");

    if (activeTableBody && scrollHandler && activeTableBody !== tableBody) {
      activeTableBody.removeEventListener("scroll", scrollHandler);
    }

    const contentHeight = 168;
    const arrowHeight = 10;
    const totalHeight = contentHeight + arrowHeight;
    const gap = 2;

    const spaceBelow = window.innerHeight - rect.bottom;
    const spaceAbove = rect.top;
    const threshold = totalHeight + gap + 10;

    let placement = "bottom";
    if (spaceBelow < threshold && spaceAbove > spaceBelow) {
      placement = "top";
    }

    const targetCenterX = rect.left + rect.width / 2;
    const arrowOffset = 15;

    const left = targetCenterX - arrowOffset;

    let top;
    if (placement === "bottom") {
      top = rect.bottom + arrowHeight + gap;
    } else {
      top = rect.top - (contentHeight + arrowHeight + gap);
    }

    state.style = {
      position: "fixed",
      top: `${top}px`,
      left: `${left}px`,
      zIndex: 9999,
    };
    state.placement = placement;
    state.text = (text || "").slice(0, 30);

    if (tableBody) {
      activeTableBody = tableBody;
      if (!scrollHandler) {
        scrollHandler = () => hide();
        activeTableBody.addEventListener("scroll", scrollHandler, {
          once: true,
        });
      }
    }

    setTimeout(() => {
      state.visible = true;
    }, 0);
  };

  return {
    state,
    show,
    hide,
  };
};
